import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _styled from "@emotion/styled-base";

function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

import React, { useState } from 'react';
// Import Components
import { HamburgerMenu } from '../HamburgerMenu';
import { Navigation } from '../Navigation'; // Styled Components via Emotion

var HeaderBannerWrapper = _styled("div", {
  target: "e1by2q9o0",
  label: "HeaderBannerWrapper"
})(process.env.NODE_ENV === "production" ? {
  name: "524ix8",
  styles: "height:auto;position:relative;width:100%;"
} : {
  name: "524ix8",
  styles: "height:auto;position:relative;width:100%;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
/**
 * This is the Header Banner App Component
 *
 * @param {Boolean} props.isOverlappingHero :: determines if the navigation links are overlapping the hero image
 * TODO: this will be deprecated after the new header is rolled out
 */


export function Header(_ref) {
  var _ref$isOverlappingHer = _ref.isOverlappingHero,
      isOverlappingHero = _ref$isOverlappingHer === void 0 ? false : _ref$isOverlappingHer;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isSoloSearchVisible = _useState2[0],
      setSoloSearch = _useState2[1];

  var handleSearchNavClick = function handleSearchNavClick() {
    setSoloSearch(!isSoloSearchVisible);
  };

  var updateSoloSearchVisibility = function updateSoloSearchVisibility() {
    setSoloSearch(false);
  };

  return /*#__PURE__*/React.createElement(HeaderBannerWrapper, null, /*#__PURE__*/React.createElement(Navigation, {
    handleSearchNavClick: handleSearchNavClick,
    isOverlappingHero: isOverlappingHero
  }), /*#__PURE__*/React.createElement(HamburgerMenu, {
    isSoloSearchVisible: isSoloSearchVisible,
    updateSoloSearchVisibility: updateSoloSearchVisibility
  }));
}
export default Header;